'use client';

import { Box, Container, Text } from '@chakra-ui/react';
import { IBranch } from '@/_types';
import BrandSingleMobile from './tabs/products';
import Gallery from './tabs/gallery';
import { useCategoryWithProducts } from '@/features/brand-menu';
import RestaurantHeader from './restarant-header';
import { useSearchParams } from 'next/navigation';
import CategoriesSection from './components/categories-section';
import { useRef } from 'react';
import { useQueryState } from 'nuqs';
import Reviews from './tabs/reviews';
import About from './tabs/about';

interface BrandSingleProps {
  data: IBranch | null;
  shipperId: string;
}

const BrandSingle: React.FC<BrandSingleProps> = ({
  data, shipperId
}) => {
  const menuId = data?.menu_id || ""

  const [activeTab] = useQueryState("active");
  const searchParams = useSearchParams();
  const tagIds = searchParams.get('tag_ids');
  const sort = searchParams.get('sort');

  const catalogRef = useRef<HTMLDivElement | null>(null);

  const { data: categories = [] } = useCategoryWithProducts({
    menuId,
    shipperId: shipperId || "",
    enabled: Boolean(shipperId),
    tag_ids: tagIds || undefined,
    sort: sort || undefined,
  });


  if (!data?.id) {
    return (
      <div>
        <RestaurantHeader branch={data} />
        <Container mt={4}>
          <Text>Brand not found</Text>
        </Container>
      </div>
    );
  }

  return (
    <Box bg='#fff' minH={'100dvh'} pb="70px">
      <RestaurantHeader branch={data} />
      <CategoriesSection
        catalogRef={catalogRef}
        categories={categories}
      />
      {activeTab === 'gallery' && data && (
        <Container>
          <Gallery data={data} />
        </Container>
      )}
      {activeTab === "menu" && (
        <BrandSingleMobile
          data={data}
          categories={categories}
        />
      )}
      {activeTab === 'reviews' && data && (
        <Container>
          <Reviews data={data} />
        </Container>
      )}
      {activeTab === 'about' && data && (
        <Container>
          <About data={data} />
        </Container>
      )}
    </Box>
  );
};

export default BrandSingle;
